"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const SvgEntryOtp = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M21.06,5.768l0.132,-0.132c0.391,-0.391 0.391,-1.024 0,-1.414l-1.414,-1.414c-0.391,-0.391 -1.024,-0.391 -1.414,0l-0.132,0.132c-1.248,-0.861 -2.684,-1.465 -4.232,-1.75l0,-0.19c0,-0.552 -0.448,-1 -1,-1l-2,0c-0.552,0 -1,0.448 -1,1l0,0.19c-5.119,0.942 -9,5.419 -9,10.81c0,6.075 4.925,11 11,11c6.075,0 11,-4.925 11,-11c0,-2.315 -0.719,-4.46 -1.94,-6.232Zm-9.06,15.232c-4.963,0 -9,-4.037 -9,-9c0,-4.963 4.037,-9 9,-9c4.963,0 9,4.037 9,9c0,4.963 -4.037,9 -9,9Zm0,-14c-0.55,0 -1,0.45 -1,1l0,3.586l-1.294,-1.294c-0.389,-0.389 -1.025,-0.389 -1.414,0c-0.389,0.389 -0.389,1.025 0,1.414c0,0 2.99,2.985 2.995,2.99c0.181,0.186 0.433,0.304 0.713,0.304c0.55,0 1,-0.45 1,-1l0,-6c0,-0.55 -0.45,-1 -1,-1Z" })));
exports.default = SvgEntryOtp;
